import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import TaskDetail from './pages/TaskDetail';
import Users from './pages/Users';
import Snapshot from './pages/Snapshot';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import JoinInvite from './pages/JoinInvite';

const ROLES_BOSS_MANAGER = ['boss', 'manager'];
const ROLES_BOSS = ['boss'];

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function Loading() {
  return <div className="min-h-screen flex items-center justify-center font-mono text-sm text-zinc-500">LOADING...</div>;
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
            <Routes>
              <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
              <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/join/:code" element={<JoinInvite />} />
              <Route path="/" element={<Protected><Dashboard scope="all" /></Protected>} />
              <Route path="/mine" element={<Protected><Dashboard scope="mine" /></Protected>} />
              <Route path="/general" element={<Protected><Dashboard scope="general" /></Protected>} />
              <Route path="/created" element={<Protected roles={ROLES_BOSS_MANAGER}><Dashboard scope="created" /></Protected>} />
              <Route path="/snapshot" element={<Protected roles={ROLES_BOSS_MANAGER}><Snapshot /></Protected>} />
              <Route path="/tasks/:id" element={<Protected><TaskDetail /></Protected>} />
              <Route path="/users" element={<Protected roles={ROLES_BOSS_MANAGER}><Users /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
